import request from '@/utils/request'

// 激活码

let CodeRoleApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.code_role/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.code_role/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.code_role/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.code_role/edit', data, errorback);
    },

    /*取权限范围*/
    roleIds(data, errorback) {
        return request._post('/shop/study.code_role/roleIds', data, errorback);
    },
}

export default CodeRoleApi;



// WEBPACK FOOTER //
// ./src/api/study/code_role.js